/**
 * Mega Menu - Learn Section
 * Handles hover (desktop) and click (mobile) interactions
 */

(function() {
  'use strict';
  
  function initMegaMenu() {
    // Desktop: Hover behavior is handled by CSS
    // We add click support for accessibility
    const desktopTrigger = document.querySelector('.mega-menu-trigger > a');
    
    if (desktopTrigger) {
      desktopTrigger.addEventListener('click', function(e) {
        const trigger = this.closest('.mega-menu-trigger');
        const isActive = trigger.classList.contains('is-active');
        
        // On desktop, allow click-through to the Learn page
        // Only prevent if trying to toggle on touch devices
        if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
          if (!isActive) {
            e.preventDefault();
            trigger.classList.add('is-active');
          }
        }
      });
      
      // Close on click outside
      document.addEventListener('click', function(e) {
        const trigger = document.querySelector('.mega-menu-trigger');
        if (trigger && !trigger.contains(e.target)) {
          trigger.classList.remove('is-active');
        }
      });
      
      // Close on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          const trigger = document.querySelector('.mega-menu-trigger');
          if (trigger) {
            trigger.classList.remove('is-active');
          }
        }
      });
    }
    
    // Mobile: Click to expand/collapse
    const mobileTrigger = document.querySelector('.mobile-menu-learn-trigger');
    
    if (mobileTrigger) {
      mobileTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        
        const isOpen = this.classList.contains('is-open');
        const menuContent = document.getElementById('mobile-mega-menu-learn');
        
        if (isOpen) {
          this.classList.remove('is-open');
          this.setAttribute('aria-expanded', 'false');
          if (menuContent) {
            menuContent.classList.remove('is-open');
          }
        } else {
          this.classList.add('is-open');
          this.setAttribute('aria-expanded', 'true');
          if (menuContent) {
            menuContent.classList.add('is-open');
          }
        }
      });
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
})();